import ExternalLinksForgotHandler from './external_links_forgot_handler';

/**
 * Handler for FYP
 */
class ExternalLinksForgotPasswordHandler extends ExternalLinksForgotHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksFYPHandler';
    static HandlerName = 'forgot_password';
}

export default ExternalLinksForgotPasswordHandler;